import React from 'react'

interface IconProps {
  color: string
}

const ExclamationMark = ({ color }: IconProps) => (
  <svg id="lnr-warning" viewBox="0 0 1024 1024" fill={color} width="30px" height="30px">
    <title>warning</title>
    <path d="M947.2 972.8h-921.6c-9.094 0-17.507-4.826-22.099-12.677s-4.672-17.547-0.214-25.474l460.8-819.2c4.536-8.061 13.066-13.050 22.314-13.050s17.778 4.989 22.312 13.050l460.8 819.2c4.459 7.926 4.376 17.624-0.214 25.474-4.592 7.851-13.002 12.677-22.098 12.677zM69.371 921.6h834.056l-417.027-741.382-417.029 741.382z"></path>
    <path d="M486.4 716.8c-14.138 0-25.6-11.461-25.6-25.6v-256c0-14.138 11.462-25.6 25.6-25.6s25.6 11.462 25.6 25.6v256c0 14.139-11.462 25.6-25.6 25.6z"></path>
    <path d="M486.4 870.4c-14.138 0-25.6-11.461-25.6-25.6v-51.2c0-14.139 11.462-25.6 25.6-25.6s25.6 11.461 25.6 25.6v51.2c0 14.139-11.462 25.6-25.6 25.6z"></path>
  </svg>
)

export default ExclamationMark
